<template>
    <section class="content px-3">
        <div class="card">
            <div class="card-header">
                <div class="card-title pt-1 mb-0">
                    <router-link :disabled="isLoading" class="btn btn-link" :to="'/pengisian-dana-gudang'">
                        <i class="fas fa-chevron-left"></i>
                    </router-link>
                    <i class="fas fa-history"></i> Riwayat Dana Gudang
                </div>
                <div class="card-tools mr-0">
                    <button :disabled="isLoading" type="button" class="btn btn-primary" @click="printList">
                        <i class="fas fa-print"></i> Print
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="mb-3">
                    <search-bar @search-set="searchSet" @search-reset="searchReset"></search-bar>
                </div>
                <div class="table-responsive">
                    <vuetable ref="vuetable"
                        api-url="/api/rekening-gudangs"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="action" slot-scope="props">
                            <button v-if="($can('create pengisian dana gudang') && isSameDay(props.rowData.created_at)) || isSuperAdmin" type="button" title="Edit" @click="edit(props.rowData)" class="btn btn-link px-1"><i class="fas fa-edit"></i></button>
                            <button v-if="isSuperAdmin" type="button" title="Delete" @click="deleteItem(props.rowData)" class="btn btn-link px-1 text-danger"><i class="fas fa-trash-alt"></i></button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </div>
        </div>

        <b-modal v-model="editModal" size="md" :hide-header="true" :hide-footer="true">
            <edit-form v-if="currentRekeningGudang" :value="currentRekeningGudang" :gudang="currentRekeningGudang.gudang" @saved="saved" @cancel="editModal = false"></edit-form>
		</b-modal>
    </section>
</template>

<script>
import VuetableMixin from '../../mixin/vuetable2';
import SearchBar from './SearchBar';
import ExportMixin from '../../mixin/export';
import EditForm from './Form';

export default {
    name: "pengisian-dana-gudang",

    components: {
        SearchBar,
        EditForm,
    },

    mixins: [VuetableMixin, ExportMixin],

    data() {
        return {
            perPage: 10,
            currentRekeningGudang: null,
            searchText: '',
            searchDate: '',
            searchGudangId: '',
            editModal: false,
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
        customFields() {
            return [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'updated_at',
                    title: 'Tanggal',
                    sortField: 'updated_at',
                    callback: 'formatDate',
                },
                {
                    name: 'gudang.name',
                    title: 'Gudang',
                    sortField: 'gudang_name',
                },
                {
                    name: 'nominal',
                    title: 'Nominal',
                    sortField: 'nominal',
                    callback: 'formatNumber',
                },
                {
                    name: 'notes',
                    title: 'Keterangan',
                    sortField: 'notes',
                },
                {
                    name: '__slot:action',
                    title: 'Aksi',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ]
        },

        sortOrder() {
            return [
                { field: "updated_at", direction: "desc" }
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
                date: this.searchDate,
                gudang_id: this.searchGudangId,
            };
        },
    },

    methods: {
        searchSet(search) {
            this.searchText = search.searchText;
            this.searchDate = search.searchDate;
            this.searchGudangId = search.searchGudangId;
            this.refresh();
        },

        searchReset() {
            this.searchText = '';
            this.searchDate = '';
            this.searchGudangId = '';
            this.refresh();
        },

        edit(rowData) {
            this.currentRekeningGudang = Object.assign({}, rowData);
            this.editModal = true;
        },

        saved() {
            this.editModal = false;
            this.currentRekeningGudang = null;
            this.refresh();
        },

        printList() {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            let params = this.convertExportParams('print');
            newIframe.src = `/rekening-gudangs/list/print` + '?' + params;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },

        deleteItem(rowData) {
            let self = this;

            Swal.fire({
                title: 'Apakah anda yakin?',
                text: "Anda tidak dapat mengembalikan data yang sudah dihapus!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ya, hapus!'
            }).then((result) => {
                // Send request to the server
                if (result.value) {
                    self.isLoading = true;
                    self.$Progress.start();
                    axios({
                        method: 'delete',
                        url: '/api/rekening-gudangs/' + rowData.id,
                    })
                    .then(function (response) {
                        Toast.fire({
                            icon: 'success',
                            title: response.data.message
                        });
                        self.isLoading = false;
                        self.$Progress.finish();
                        self.refresh();
                    })
                    .catch(function (error) {
                        self.responseFailed(error);
                    });
                }
            })
        },
    },
}
</script>
